import axios from 'axios'

axios.defaults.baseURL = process.env.API_URL
axios.defaults['Content-type'] = 'application/json'
axios.defaults.Accept = 'application/json'

const instance = axios.create()

export default instance
